import { AccountingSoftwareType } from './organization-config-enums';

/**
 * Represents a resource from the /gyms/ API collection.
 */
export enum LocationSchedulerFirstDayOfWeek {
  sunday = 'SUN',
  monday = 'MON'
}

export enum LocationDefaultStaffSiteEventsView {
  scheduledEventsList = 'LIS',
  calendar = 'CAL',
}

/**
 * Whether a customer must hold ANY one, or ALL, of a location's required
 * check-in proficiencies to avoid the Check-In Site's missing-proficiency
 * alert (PRO-1451). Values match the API's match-mode vocabulary.
 */
export enum LocationCheckInRequiredProficienciesMatchMode {
  any = 'any',
  all = 'all',
}


export interface CapitanLocation {
  id: number;
  url: string;
  name: string;
  hide_setter: boolean;
  time_zone: string;
  scheduler_url_path: string;
  scheduler_landing_page_text: string;
  scheduler_first_day_of_week: LocationSchedulerFirstDayOfWeek;
  default_staff_site_events_view: LocationDefaultStaffSiteEventsView;
  capacity: number;
  open_date: string;
  combine_same_day_check_ins: boolean;
  check_in_required_proficiency_ids: number[];
  check_in_required_proficiency_names: string[];
  check_in_required_proficiencies_match_mode: LocationCheckInRequiredProficienciesMatchMode;
  vat_info: string;
  allow_climber_app_home_location_selection: boolean;
  allow_climber_app_product_selection: boolean;
  today_local: string;
  lightspeed_location_id: string;
  square_location_id: string;
  accounting_connection_id: number | null;
  accounting_connection_name: string | null;
  accounting_connection_software: AccountingSoftwareType | null;
  payment_processor_connection_id: number | null;
  payment_processor_connection_name: string | null;
  mailchimp_check_in_event_name: string;
  xero_tracking_category_name: string;
  xero_tracking_category_option_name: string;
  created_at: string;
  updated_at: string;
  areas_url: string;
}

export interface LocationArea {
  id: number;
  url: string;
  name: string;
  capacity: number;
  allow_only_one_booked_event: boolean;
  gym_id: number;
  gym_name: string;
  gym_url: string;
  created_at: string;
  updated_at: string;
}

export interface StripeReader {
  id: number;
  location_id: number;
  location_name: string;
  label: string;
  created_at: string;
  updated_at: string;
}

export interface MXMerchantUnregisteredTerminal {
  terminal_id: string;
  name: string;
  description: string;
}

/**
 * Represents the set of field filters available for the /gym-areas/ API
 * collection.
 */
export interface LocationAreaFilters {
  gym_id?: number;
}
